<template>
  <div class="main-wrapper scroll-y custom-scrollbar view-training-summary" style="background: #fff">

    <!--passed test-->
    <div v-if="summary && (summary.pass_test == true || summary.pass_exam == true)" class="mt-20 text-center">
      <div class="mt-20 text-center">
        <slide-y-up-transition :duration="700">
          <h2 v-if="show">Gratulacje! Pozytywny wynik.</h2>
        </slide-y-up-transition>
        <slide-y-up-transition :duration="500" :delay="200">
          <h3 v-if="show" class="text-green">{{ summary.user_points }} / {{ summary.total_points }} punktów</h3>
        </slide-y-up-transition>

        <div class="inner-padding">
          <card-training-progress></card-training-progress>
        </div>

        <p v-if="nextTrainingItem"><strong>Następna lekcja:</strong></p>

        <item-training
            v-if="nextTrainingItem"
            :index="currentSlugIndex+1"
            :slug="nextTrainingItem.slug"
            :title="nextTrainingItem.title"
            :excerpt="nextTrainingItem.excerpt"
            :time="nextTrainingItem.time"
            :content="nextTrainingItem.subtitle"
            :image="nextTrainingItem.image"
            :done="nextTrainingItem.passed_test"
            :has_steps="nextTrainingItem.has_steps"
            :disabled="nextTrainingItem.disabled">
        </item-training>

        <ion-button mode="ios"
                    fill="outline"
                    size="default"
                    @click="goToTrainings">Wróć do szkoleń
        </ion-button>
        <!--      <ion-button mode="ios"-->
        <!--                  size="default"-->
        <!--                  class="mt-10"-->
        <!--                  @click="goToNextTraining">Następna lekcja-->
        <!--      </ion-button>-->
      </div>
    </div>

    <!--failed test-->
    <div v-if="summary && (summary.pass_test == false || summary.pass_exam == false)" class="mt-20 text-center">
      <slide-y-up-transition :duration="700">
        <h2 v-if="show">Twój wynik: {{ summary.user_points }} / {{ summary.total_points }} punktów</h2>
      </slide-y-up-transition>
      <slide-y-up-transition :duration="700" :delay="200">
        <p v-if="show">Niestety, nie uzyskano wymaganej ilości punktów.</p>
      </slide-y-up-transition>
      <!--<h6 class="text-up text-gray-light mb-20">Twoje odpowiedzi</h6>-->
      <ion-list class="text-left">
        <ion-item-group v-for="(question,q_index) in result" :key="q_index">
          <ion-item-divider style="padding: 8px 14px">
            <h6 v-if="show" class="m-0 text-gray-light">{{ q_index }}</h6>
          </ion-item-divider>
          <ion-item v-for="(answer,a_index) in result[q_index]" :key="a_index">
            <p v-if="show" :class="answer.correctness === true ? 'text-green' : 'text-red'">
              <b>{{ answer.answer }}</b>
            </p>
          </ion-item>
        </ion-item-group>
      </ion-list>

      <slide-y-up-transition :duration="700" :delay="500">
        <div v-if="show" style="padding: 0 0 15px">
          <ion-button mode="ios"
                      v-if="summary.pass_test == false"
                      fill="outline"
                      class="mb-20"
                      @click="goTo('TrainingSingle', $route.params.slug)">Wróć do szkolenia
          </ion-button>
          <ion-button mode="ios"
                      v-if="summary.pass_test == false"
                      class="mb-20"
                      @click="goTo('TrainingTest', $route.params.slug)">Ponów test
          </ion-button>
          <ion-button mode="ios"
                      v-if="summary.pass_exam == false"
                      class="mb-20"
                      @click="goTo('TrainingExam', $route.params.slug)">Ponów egzamin
          </ion-button>
        </div>
      </slide-y-up-transition>
    </div>

  </div>
</template>

<script>
import goTo from '@/mixins/goto';
import {mapState} from 'vuex';
import ItemTraining from '@/items/ItemTraining';
import CardTrainingProgress from '@/cards/CardTrainingProgress.vue';

export default {
  name: 'TrainingSummary',
  components: {CardTrainingProgress, ItemTraining},
  mixins: [goTo],
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapState({
      loading: state => state.trainings.loading,
      answers: state => state.trainings.answers,
      summary: state => state.trainings.summary,
      lessons: state => state.trainings.lessons,
    }),
    // prepare result from user's answers
    result() {
      return this.answers.reduce(function (r, a) {
        r[a.question] = r[a.question] || [];
        r[a.question].push(a);
        return r;
      }, {});
    },
    currentSlug() {
      return this.$route.params.slug
    },
    currentSlugIndex() {
      let index = this.lessons.map((item) => {
        return item.slug
      }).indexOf(this.currentSlug);
      return index
    },
    nextTrainingItem() {
      if (this.lessons[this.currentSlugIndex + 1]) {
        return this.lessons[this.currentSlugIndex + 1]
      }
    }
  },
  mounted() {
    this.show = true;
    // prevent user coming here without completing the test
    setTimeout(() => {
      !this.answers ? this.goBack() : false;
    }, 300)
    // update user profile if test / exam is passed correctly
    if (this.summary.pass_test == true) {
      this.$store.dispatch('profile/PROFILE_LESSON_PASSED', {root: true})

    }
  },
  methods: {
    // goToNextTraining() {
    //   this.goTo('TrainingSingle', this.nextTrainingItem.slug)
    // },
    goToTrainings() {
      // fetch new trainings
      this.$store.dispatch('trainings/KNOWLEDGE_TRAININGS_REQUEST').then(() => {
        // and then move back to list
        // (basically we want to button status to update)
        this.goTo('Trainings')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
ion-card {
  margin: 15px 0;
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
  border-radius: 0;
  box-shadow: none;
}
</style>
